import { useOnlineStatus } from '@/hooks/useOnlineStatus';

export function OfflineBanner() {
  const online = useOnlineStatus();
  if (online) return null;
  return (
    <div
      role="status"
      aria-live="polite"
      className="bg-(--color-warning,#f59e0b) px-4 py-2 text-center text-xs font-medium text-(--color-bg)"
    >
      Modo offline — algumas ações estão desabilitadas
    </div>
  );
}
